import {ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { ModalService } from '../../services/modal/modal.service';
import { HelpersService } from '../../services/helpers.service';
import { ContractAvatarsService } from '../../modules/contracts/services/contract-avatar.service';
import { IMemberWithRole, MemberModel } from '../../models/user.model';


@Component({
    selector: 'app-avatar-list',
    templateUrl: './avatar-list.component.html',
    styleUrls: ['./avatar-list.component.scss']
})
export class AvatarListComponent  {
    @Input() users: IMemberWithRole[] = [];
    @Output() eventUserDelete:EventEmitter<MemberModel> = new EventEmitter<MemberModel>()
    private subs: Subscription = new Subscription();
    
    constructor(
        public modalService: ModalService,
        public helper: HelpersService,
        public translate: TranslateService,
        private contractAvatarsService: ContractAvatarsService,
        private cds: ChangeDetectorRef,
    ) {
    }
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
    ngOnInit(): void {
        this.setSubscriptions()
    }
    setSubscriptions() {
        this.subs.add(this.contractAvatarsService.bSubAvatarsReady.asObservable().subscribe(()=>this.cds.detectChanges()))
    }
    deleteUser(user:MemberModel) {
        this.eventUserDelete.emit(user)
    }
}